import { render, staticRenderFns } from "./BSignUp.vue?vue&type=template&id=ed9f1b3a&scoped=true&"
import script from "./BSignUp.vue?vue&type=script&lang=ts&"
export * from "./BSignUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9f1b3a",
  null
  
)

export default component.exports